import { Component, Inject, Renderer2 } from '@angular/core';
import { Constants } from '../../common/constants';
import Swiper from 'swiper'; 
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.css']
})
export class CareersComponent {
  baseUrl = Constants.baseUrl;
  constructor(
    private titleService: Title,
    private metaService: Meta, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,private seoService:SeoService
  ) {}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/careers/"
  },
  "headline": "Jobs, Careers and Opportunities | Maganti IT",
  "description": "Your spark is just a step away. Take action, grab the opportunity and demonstrate that you are the right person for the job.",
  "image": "https://mitresource.com/assets/images/techtraining_images/training_carouselimg.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-06-28"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Jobs, Careers and Opportunities | Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'Your spark is just a step away. Take action, grab the opportunity and demonstrate that you are the right person for the job.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Jobs, Careers and Opportunities | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/careers/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/techtraining_images/training_carouselimg.png' },
      { property: 'og:description', content: 'Your spark is just a step away. Take action, grab the opportunity and demonstrate that you are the right person for the job.' },
    ]);
  }
}
